<template>
    <div class="table-view">
        <div class="table-view-row head" :class="{ 'sticky-head' : stickyHead }" :style="`grid-template-columns: ${size.join(' ')}`">
            <div class="col text-overflow" :key="key" v-for="(item, key) of head">{{ item.name }}</div>
        </div>
        <div><slot></slot></div>
        <div class="loader" v-if="loading"></div>
    </div>
</template>

<script>
    export default {
        props: {
            head: { type: Array, required: true },
            size: { type: Array, required: true },
            loading: { type: Boolean, required: false },
            stickyHead: { type: Boolean, required: false },
        }
    }
</script>

<style lang="scss">
.table-view {
    position: relative;
    border-bottom: 1px solid $borderColor;
    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff82;
        z-index: 2;
    }
    .table-view-row {
        display: grid;
        column-gap: 10px;
        align-items: center;
        padding: 10px;
        transition: ease 0.3s;
        font-weight: 400;
        font-size: 12px;
        min-height: 44px;
        width: 100%;
        border-bottom: 1px solid $borderColor;
        &:last-child {
            border: 0;
        }
        &.head {
            height: auto;
            min-height: 34px;
            border-bottom: 1px solid $borderColor;
            border-radius: 0;
            padding: 10px 10px;
            .col {
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
            }
            &.sticky-head {
                position: sticky;
                top: 0;
                left: 0;
                background: $bg;
                z-index: 2;
            }
        }
        &.row-hover {
            &:hover {
                background: $bg;
                box-shadow: $boxShadow;
            }
        }
    }
}
</style>